import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiUrl } from '../../../utils/ApiUtils';

export function BuildInfo() {
  const [backendVersion, setBackendVersion] = useState(null);
  const [loading, setLoading] = useState(true);

  // Frontend build info from environment variables
  const frontendSha = process.env.REACT_APP_BUILD_SHA;
  const frontendTag = process.env.REACT_APP_BUILD_TAG;
  const frontendBranch = process.env.REACT_APP_BUILD_BRANCH;
  const frontendBuildNo = process.env.REACT_APP_BUILD_NUMBER;
  const frontendBuiltAt = process.env.REACT_APP_BUILD_DATE;

  // Check if we're in a built environment (has build metadata)
  const isBuiltEnvironment = frontendSha || frontendBuildNo;

  useEffect(() => {
    let cancelled = false;

    const fetchBackendVersion = async () => {
      try {
        const versionUrl = getApiUrl('generic/version');
        const response = await axios.get(versionUrl, { withCredentials: true });
        if (!cancelled) setBackendVersion(response.data);
      } catch (error) {
        if (!cancelled) console.error('Failed to fetch backend version:', error);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchBackendVersion();

    return () => { cancelled = true; };
  }, []);

  // Don't show anything in local development
  if (!isBuiltEnvironment && !backendVersion?.commit && !loading) {
    return null;
  }

  const formatVersionLine = (label, tag, branch, sha, buildNo, deployedAt) => {
    const shortSha = sha ? sha.slice(0, 7) : null;
    const versionLabel = tag || branch || null;

    // Don't show line if no meaningful data
    if (!versionLabel && !shortSha && !buildNo) {
      return null;
    }

    return (
      <div style={{ fontSize: 11, opacity: 0.6, marginBottom: 2 }}>
        {label}: {versionLabel || "dev"} {shortSha ? `• ${shortSha}` : ""}
        {buildNo ? ` • build ${buildNo}` : ""}
        {deployedAt ? ` • ${deployedAt}` : ""}
      </div>
    );
  };

  const frontendLine = formatVersionLine(
    "Frontend",
    frontendTag,
    frontendBranch,
    frontendSha,
    frontendBuildNo,
    frontendBuiltAt
  );

  const backendLine = !loading && backendVersion ? formatVersionLine(
    "Backend",
    backendVersion.version,
    backendVersion.branch,
    backendVersion.commit,
    backendVersion.buildNumber,
    backendVersion.deployedAt
  ) : null;

  // Only render if we have at least one line to show
  if (!frontendLine && !backendLine && !loading) {
    return null;
  }

  return (
    <div style={{
      fontSize: 11,
      opacity: 0.6,
      marginTop: 8,
      paddingTop: 8,
      borderTop: '1px solid rgba(128, 128, 128, 0.2)'
    }}>
      {frontendLine}
      {backendLine}
      {loading && (
        <div style={{ fontSize: 11, opacity: 0.6 }}>
          Backend: Loading...
        </div>
      )}
    </div>
  );
}
